import { GlAvatar, GlBadge, GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { getBaseURL, isExternal, setUrlParams } from '~/lib/utils/url_utility';
import { __ } from '~/locale';
import toast from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/plugins/global_toast.js?vue3';
import { DECISION_LOG_PANEL, DETAIL_VIEW_QUERY_PARAM_NAME } from '~/work_items/constants';
import { DECISION_ANCHOR_PREFIX, DECISION_STATE_ARCHIVED } from './constants';
import { decisionSourceUrl, decisionText, settledDecisionOptions } from './utils';
import DecisionLogContext from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/components/decision_log/decision_log_context.vue?vue3';
export default {
    name: 'DecisionLogItem',
    components: {
        DecisionLogContext,
        GlAvatar,
        GlBadge,
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        GlLink,
        TimeAgoTooltip
    },
    props: {
        decision: {
            type: Object,
            required: true
        },
        workItemWebUrl: {
            type: String,
            required: true
        },
        // The anchor the reader arrived on. The panel owns the hash and hands it to every card.
        targetAnchor: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'view-comment',
        'edit',
        'archive'
    ],
    computed: {
        anchorId () {
            return `${DECISION_ANCHOR_PREFIX}${getIdFromGraphQLId(this.decision.id)}`;
        },
        isTarget () {
            return this.targetAnchor === this.anchorId;
        },
        isArchived () {
            return this.decision.state === DECISION_STATE_ARCHIVED;
        },
        archivedTextClass () {
            return {
                'gl-text-subtle': this.isArchived
            };
        },
        // The link has to land somewhere the reader can see, so it points at the whole work item, with
        // the param that reopens this panel and the hash that highlights this card.
        decisionUrl () {
            const workItemUrl = new URL(this.workItemWebUrl, getBaseURL()).href;
            const panelUrl = setUrlParams({
                [DETAIL_VIEW_QUERY_PARAM_NAME]: DECISION_LOG_PANEL
            }, {
                url: workItemUrl,
                clearParams: true
            });
            return `${panelUrl}#${this.anchorId}`;
        },
        settledOptions () {
            return settledDecisionOptions(this.decision);
        },
        heading () {
            return decisionText(this.decision);
        },
        // The question already heads the card when nothing was settled, so it is not repeated below.
        questionSubhead () {
            return this.settledOptions.length ? this.decision.title : null;
        },
        sourceUrl () {
            return decisionSourceUrl(this.decision);
        },
        // A link outside GitLab cannot be reached by moving the panel aside, so it opens in its own
        // tab and leaves the work item where the reader left it.
        isSourceExternal () {
            return Boolean(this.sourceUrl) && isExternal(this.sourceUrl);
        },
        sourceTarget () {
            return this.isSourceExternal ? '_blank' : null;
        },
        hasContext () {
            return Boolean(this.decision.description || this.decision.resolutionRationale);
        }
    },
    async mounted () {
        if (!this.isTarget) return;
        // The panel mounts the card, so the scroll waits for that to settle before it measures.
        await this.$nextTick();
        this.$el.scrollIntoView({
            block: 'center'
        });
    },
    methods: {
        // The panel only has to move aside for a link that lands on the page behind it.
        onSourceClick () {
            if (this.isSourceExternal) return;
            this.$emit('view-comment');
        },
        notifyLinkCopied () {
            toast(__('Link copied to clipboard.'));
        }
    }
};
